import messagesDE from './de.json';
import messagesEN from './en.json';
import messagesFR from './fr.json';

interface IMessages {
  [key: string]: any;
}

export const messages: IMessages = {
  de: messagesDE,
  en: messagesEN,
  fr: messagesFR,
};
